var collapsible_list_pair_rtlignore_default = {
  "container": "xVEPk",
  "title": "XC0RQ",
  "viewerContainer": "VTYn7",
  "titleContainer": "_4nqlj",
  "expandIcon": "SrrfC",
  "dndIcon": "ettEw",
  "RTL": "LofPP",
  "LTR": "Bi7a9",
  "itemContainer": "ucgj6",
  "itemContainerViewer": "sBkoG",
  "mouseDown": "G92bR",
  "innerEditor": "nGgAJ",
  "item": "OohKy",
  "floatingAddPluginMenuWrapper": "_2HBSi",
  "childrenHidden": "K-wMa"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
